import { createContext, useContext, useMemo } from 'react';

export interface WalletBalanceContextType {
  balance: number;
  isLoading: boolean;
}

export interface WalletActionsContextType {
  refreshBalance: () => Promise<void>;
}

export interface WalletContextType extends WalletBalanceContextType, WalletActionsContextType {}

export const WalletBalanceContext = createContext<WalletBalanceContextType | undefined>(undefined);
export const WalletActionsContext = createContext<WalletActionsContextType | undefined>(undefined);

export function useWalletBalance(): WalletBalanceContextType {
  const context = useContext(WalletBalanceContext);
  if (context === undefined) {
    throw new Error('useWalletBalance must be used within a WalletProvider');
  }
  return context;
}

export function useWalletActions(): WalletActionsContextType {
  const context = useContext(WalletActionsContext);
  if (context === undefined) {
    throw new Error('useWalletActions must be used within a WalletProvider');
  }
  return context;
}

export function useWallet(): WalletContextType {
  const balance = useWalletBalance();
  const actions = useWalletActions();
  return useMemo(() => ({ ...balance, ...actions }), [balance, actions]);
}
